import { render } from "./DemandForecastingSettingsPopover.vue?vue&type=template&id=2e9d47a4&scoped=true"
import script from "./DemandForecastingSettingsPopover.vue?vue&type=script&lang=js"
export * from "./DemandForecastingSettingsPopover.vue?vue&type=script&lang=js"

import "./DemandForecastingSettingsPopover.vue?vue&type=style&index=0&id=2e9d47a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9d47a4"]])

export default __exports__